import React, { useContext } from 'react';

import { Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import QuickAccess from '../../../../../shared/components/v3/Buttons/QuickAccess/QuickAccess';
import { PLAN_ROUTE } from '../../../../../shared/constants/auth';
import { END_CHALLENGE_ICON } from '../../../../../shared/constants/images';
import { CLICK_ACTION, QUICK_ACCESS, QUICK_ACCESS_PLAN } from '../../../../../shared/constants/tagManager';
import { CompanyContext } from '../../../../../shared/context/company/companyContext';
import TagManagerService from '../../../../../shared/services/gtm/tagManagerService';
import { TRANSLATIONS_HOME } from '../../../../../shared/translations/home';
import { redirectToPage } from '../../../../../shared/utils/utils';

import './DirectAccess.scss';

const DirectAccess = () => {
  const { isLoadingCompanyData } = useContext(CompanyContext);

  const { t } = useTranslation();
  const navigate = useNavigate();

  const goToMyPlan = () => {
    TagManagerService.pushEvent(CLICK_ACTION, QUICK_ACCESS, {
      quick_access_id: QUICK_ACCESS_PLAN,
      quick_access_url: PLAN_ROUTE
    });
    redirectToPage(navigate, PLAN_ROUTE);
  };

  if (isLoadingCompanyData) {
    return (
      <div className="empty-company-direct-access-content">
        <div className="direct-access-label">{t(TRANSLATIONS_HOME.shortCuts)}</div>
        <div className="flex row gap-6">
          <Skeleton className="skeleton-direct-access" variant="rectangular" />
        </div>
      </div>
    );
  }

  return (
    <div className="empty-company-direct-access-content" data-experience="new">
      <div className="direct-access-label">{t(TRANSLATIONS_HOME.shortCuts)}</div>
      <QuickAccess icon={END_CHALLENGE_ICON} description={t(TRANSLATIONS_HOME.quickAccess.plan)} action={goToMyPlan} />
    </div>
  );
};

export default DirectAccess;
